import { QueryEntity } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { AbsenceItemsState, AbsenceItemsStore } from './absence-items.store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AbsenceItemsQuery extends QueryEntity<AbsenceItemsState> {
  selectedAbsence$: Observable<string>;

  constructor(protected store: AbsenceItemsStore) {
    super(store);
    this.selectedAbsence$ = this.selectActive().pipe(
      map((absence) =>
        absence?.absenceNr ? absence.absenceNr + ' ' + absence.name : ''
      )
    );
  }
}
